import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class WhRcvListItem extends SearchModelBase {
    status: string = '';
    closed: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    isVoid: number = 0;
    receiveNo: string = '';
    branch: string = '';
    centerNo: string = '';
    receiveDate: string | null = null;
    orderDate: string | null = null;
    rcvStatus: string = '';
    p: string = '';
    poNo: string = '';
    soNo: string = '';
    vendor: string = '';
    trucker: string = '';
    remark: string = '';
    palletRemark: string = '';
    id: number = 0;
    fromReceiveDate: string | null = null;
    toReceiveDate: string | null = null;
    fromOrderDate: string | null = null;
    toOrderDate: string | null = null;
    createdAt: string | null = null;    
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2Date: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    u2ID: string = '';
    u1ID: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'INV', width: 35, dataIndex: 'invStat', noNullOrEmptySearch: true,  align: XCol.XAlignType.Center  }),
        XCol.Create({ col: 2, text: 'BIL', width: 35, dataIndex: 'billStat', noNullOrEmptySearch: true, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 3, text: 'CrDb', width: 35, dataIndex: 'crDbStat', noNullOrEmptySearch: true, align: XCol.XAlignType.Center }),
        // XCol.Create({ col: 1, text: 'V', width: 35, dataIndex: 'isVoid', type: XCol.XCellType.StrBool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 4, text: 'Receiving ID', width: 100, dataIndex: 'receiveNo', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 6, text: 'Customer (WH)', width: 120, dataIndex: 'centerNo'}),
        XCol.Create({ col: 7, text: 'In Date', width: 75, dataIndex: 'receiveDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 8, text: 'Order Date', width: 75, dataIndex: 'orderDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 9, text: 'Status', width: 80, dataIndex: 'rcvStatus'}),
        XCol.Create({ col: 10,  text: 'Paid', width: 40, dataIndex: 'p', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 11,  text: 'S/O #', width: 80, dataIndex: 'soNo'}),
        XCol.Create({ col: 12,  text: 'Ship From', width: 100, dataIndex: 'vendor'}),
        XCol.Create({ col: 13, text: 'Carrier', width: 100, dataIndex: 'trucker'}),
        XCol.Create({ col: 14, text: 'Pallet', width: 100, dataIndex: 'palletRemark'}),
        XCol.Create({ col: 15, text: 'Remark', width: 150, dataIndex: 'remark'}),
        XCol.Create({ col: 16, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 17, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 18, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 19, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        // 2023-10-19 jhchoi : Void 컬럼 제거(추후에 사용할 경우 주석 제거)
        // return this.ExportCollection;
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: WhRcvListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: WhRcvListItem[]) {
        return data.map((d: WhRcvListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        receiveDate: {from: 'fromReceiveDate', to: 'toReceiveDate'},
        orderDate: {from: 'fromOrderDate', to: 'toOrderDate'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
    }
}
